exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".onboarding{z-index:1000;position:absolute;left:0;top:0;width:100%;height:100vh;background-color:transparent;display:-ms-flexbox;display:flex}.modal-dialog.onboarding-modal .modal-header{text-transform:uppercase}.modal-dialog.onboarding-modal .modal-header.empty-title{text-align:center}.onboarding>div{-ms-flex-align:stretch;align-items:stretch;width:100%;height:100%}.onboarding>div>div.modal-dialog{position:relative;width:420px;padding:10px;margin-left:auto;margin-right:auto;top:50%;transform:translateY(-60%)}.onboarding>div>svg{position:absolute;top:0;left:0;width:100%;height:100vh;background-color:transparent;fill:#fff;stroke:#b4e166}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?sourceMap&includePaths[]=/tmp/ppa-firebase/src/styles!./src/views/session/presentation/components/onboarding.scss
// module id = 1311
// module chunks = 2